import styled from 'styled-components'

export const Block = styled.div`
  margin-top: 50px;
  margin-right: -23px;
  min-height: 730px;
  display: flex;
  flex-wrap: wrap;
`
